import {
  Col,
  Form,
  Input,
  Radio,
  Row,
  Space,
  Table,
  Upload,
  UploadFile,
} from 'antd';
import Button from 'components/Button';
import { DownloadIcon } from 'assets/svg';
import { MainLayout } from 'components';
import useQueryParam from 'hooks/useQueryPrams';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import pageTitleStore from 'store/pageTitleStore';
import { Content } from 'antd/es/layout/layout';
import { ColumnsType } from 'antd/es/table';
import { HocChangePagination } from 'utils/HocChangePagination';
import * as XLSX from 'xlsx';
import { openNotificationWithIcon } from 'utils/notification';
import { UploadProps } from 'antd/lib';
import AllocateApi from 'apis/Allocate';
import { useUser } from 'contexts/User';
import { useMutation } from 'react-query';

export default function PlantAllocategoodsCreate() {
  interface Iparam {
    id: string;
  }
  const { id } = useParams<Iparam>();
  const cap_shop_id = parseInt(id);
  const history = useHistory();
  const queryParam = useQueryParam();
  const [selectedFile, setSelectedFile] = useState<UploadFile>();
  const [donghangs, setDongHangs] = useState<any[]>([]);
  const [isUpdateLoading, setUpdateLoading] = useState(false);

  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size = parseInt(queryParam.get('page_size') + '') || 4;
  const functionParams = {
    page: page,
    page_size: page_size,
  };

  const params = JSON.parse(JSON.stringify(functionParams));

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  useEffect(() => {
    setTitle('Tạo Phân bổ tỷ trọng vốn theo dòng hàng');
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="">Chi nhánh</a>
          </p>
        ),
      },
      {
        title: (
          <p>
            <a href="/plants-allocate">Vốn tồn chi nhánh</a>
          </p>
        ),
      },
      {
        title: (
          <p>
            <a href="/plants-allocate">Phân bổ vốn tồn</a>
          </p>
        ),
      },
      {
        title: <a href="">Tạo Phân bổ tỷ trọng vốn theo dòng hàng</a>,
      },
    ]);
  }, []);

  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 60,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Nhãn hàng',
      dataIndex: 'nhan_hang',
      width: 120,
    },
    {
      title: 'Ngành hàng',
      dataIndex: 'nganh_hang',
      width: 120,
    },
    {
      title: 'Chủng loại',
      dataIndex: 'chung_loai',
      width: 120,
    },
    {
      title: 'Dòng hàng Xman',
      dataIndex: 'dong_hang',
      width: 180,
    },
    {
      title: 'Tỉ trọng Min (%)',
      dataIndex: 'ratio_min',
      width: 180,
    },
    {
      title: 'Tỉ trọng Max (%)',
      dataIndex: 'ratio_max',
      width: 180,
    },
    {
      fixed: 'right',
      width: 1,
    },
  ];

  function generateExcel() {
    const data = [];
    const headerRow = columns.map((column) => {
      return column.title;
    });
    data.push(headerRow);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    const dataSheet1: any = [['Nhãn hàng']];
    const wsSheet1 = XLSX.utils.aoa_to_sheet(dataSheet1);
    XLSX.utils.book_append_sheet(wb, wsSheet1, 'Nhãn hàng');

    const dataSheet2: any = [
      ['Ngành hàng'],
      ['ĐÁ'],
      ['Vàng'],
      ['Platinum'],
      ['Bạc'],
    ];
    const wsSheet2 = XLSX.utils.aoa_to_sheet(dataSheet2);
    XLSX.utils.book_append_sheet(wb, wsSheet2, 'Ngành hàng');

    const dataSheet3: any = [
      ['Chủng loại'],
      ['Bông tai'],
      ['Dây cổ'],
      ['Dây chuyền'],
      ['Kiềng'],
      ['Charm'],
      ['Lắc tay'],
      ['Mề đay'],
      ['Nhẫn'],
      ['Vòng'],
    ];
    const wsSheet3 = XLSX.utils.aoa_to_sheet(dataSheet3);
    XLSX.utils.book_append_sheet(wb, wsSheet3, 'Chủng loại');

    const dataSheet4: any = [
      ['Dòng hàng Xman'],
      ['Bạc'],
      ['Bạc Disney'],
      ['Dây chuyền 24K'],
      ['Dây chuyền 416'],
      ['Dây chuyền 750'],
      ['Dây chuyền tay'],
      ['Dây chuyền Ý'],
      ['Vàng Disney'],
      ['Kim Cương Rời'],
      ['Nhẫn cưới ECZ/CZ'],
      ['Nhẫn cưới kim cương'],
      ['Nhẫn cưới trơn'],
      ['Vàng Sanrio'],
      ['Bạc Sanrio'],
      ['Trang sức Citrine'],
      ['Trang sức trọng lượng'],
      ['Trang Sức Cz và KGD750'],
      ['Trang sức đá khác'],
      ['Trang Sức Ecz và KGD416'],
      ['Trang Sức Kim Cương'],
      ['Trang sức ngọc trai vàng'],
      ['Trang sức Ruby'],
      ['Trang sức Topaz'],
      ['Trang Sức Vỏ'],
      ['Trang Sức Ý'],
      ['Vòng kiềng 24k'],
      ['Charm'],
      ['Nam Trang'],
    ];

    const wsSheet4 = XLSX.utils.aoa_to_sheet(dataSheet4);
    XLSX.utils.book_append_sheet(wb, wsSheet4, 'Dòng hàng Xman');

    XLSX.writeFile(wb, `ty_trong_von_theo_dong_hang.xlsx`);
  }

  function hasDuplicateElements(nestedArray: Array<any>) {
    const fifthElements: any[] = nestedArray.map((subArray) => subArray[4]); // Lấy ra phần tử thứ năm của mỗi mảng con
    const uniqueSet: Set<any> = new Set(fifthElements); // Tạo một Set để loại bỏ các phần tử trùng lặp

    // Kiểm tra xem số lượng phần tử trong Set có bằng số lượng phần tử trong mảng không
    return uniqueSet.size !== fifthElements.length;
  }

  function handleUploadFile(info: UploadProps) {
    try {
      if (info.fileList) {
        const files = info.fileList.map((file: any) => {
          return file.originFileObj;
        });
        if (files.length != 0) {
          const file = info.fileList[0];
          setSelectedFile(file);
          const reader = new FileReader();

          reader.onload = (e) => {
            if (e.target) {
              const data = e.target.result;
              const workbook = XLSX.read(data, { type: 'array' });
              const firstSheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[firstSheetName];

              let excelData = XLSX.utils.sheet_to_json<any[]>(worksheet, {
                header: 1,
                range: 0,
              });

              if (
                excelData.length == 0 ||
                excelData[0].length == 0 ||
                excelData[0][0] != 'STT'
              ) {
                openNotificationWithIcon(
                  'error',
                  'File không đúng mẫu, vui lòng tải mẫu'
                );
                return;
              }
              excelData = excelData.slice(1);
              const isDuplicate = hasDuplicateElements(excelData);

              if (isDuplicate) {
                openNotificationWithIcon(
                  'error',
                  'Dòng hàng Xman bị trùng lặp! Không thể import!'
                );
                setSelectedFile(undefined);
              } else {
                const newDongHangs: any[] = [];
                excelData.forEach((row, index) => {
                  const product: any = {};
                  if (row.length != 0) {
                    for (let index = 0; index < row.length; index++) {
                      const value = row[index];
                      product[columns[index].dataIndex] =
                        value == ''
                          ? undefined
                          : columns[index].dataIndex == 'ratio_min' ||
                            columns[index].dataIndex == 'ratio_max'
                          ? Number(value)
                          : value;
                    }
                    newDongHangs.push(product);
                  }
                });

                setDongHangs(newDongHangs);
              }
            }
          };
          const blob = file.originFileObj as Blob;
          reader.readAsArrayBuffer(blob);
        }
      }
    } catch (err) {
      openNotificationWithIcon('error', 'File không đúng định dạng mẫu');
    }
  }

  const {
    // data: cartData,
    isLoading: getCartsLoading,
    mutate: importRatioProduct,
  } = useMutation(
    ['update', functionParams],
    () =>
      AllocateApi.importRatioProduct({
        data: donghangs,
        cap_shop_id: cap_shop_id,
      }),
    {
      onSuccess: (data: any) => {
        setUpdateLoading(false);
        if (data.success == 'success') {
          openNotificationWithIcon('success', 'Phân bổ thành công');
          history.push('/plants-allocate');
        } else {
          openNotificationWithIcon('error', 'Dữ liệu khai báo đang bị trống !');
        }
      },
      onError: (e: any) => {
        setUpdateLoading(false);
        openNotificationWithIcon('error', 'Dữ liệu khai báo đang bị trống !');
      },
    }
  );

  const handleUpdate = () => {
    setUpdateLoading(true);
    // const params = {
    //   data: donghangs,
    //   cap_shop_id: cap_shop_id,
    // };
    importRatioProduct();
  };

  const isTotalMinMaxInvalid = () => {
    let sumMin = 0;
    donghangs.map((item: any) => {
      sumMin = sumMin + item.ratio_min * 1;
    });

    let sumMax = 0;
    donghangs.map((item: any) => {
      sumMax = sumMax + item.ratio_max * 1;
    });

    if (sumMax > 100 || sumMin > 100) {
      return false;
    } else return true;
  };

  return (
    <MainLayout isLoading={isUpdateLoading}>
      <Content>
        <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          justify="end"
          className="mb-1"
        >
          <Col span={12}>
            <h6>Tỷ trọng vốn theo dòng hàng</h6>
          </Col>
          <Col span={12} className="flex justify-end">
            <Space>
              <Button
                bgColor={'bg-white'}
                color={'text-primary-50'}
                border="border-primary-50"
                onClick={generateExcel}
              >
                Tải mẫu tại đây
                <DownloadIcon />
              </Button>
            </Space>
          </Col>
        </Row>

        <Form layout="vertical">
          <Row align="middle" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={21}>
              <Form.Item label="Danh sách phân bổ">
                <Input
                  disabled={true}
                  placeholder="Tải file định dạng .xls, .csv"
                  className=""
                  value={selectedFile?.name}
                />
              </Form.Item>
            </Col>
            <Col span={3}>
              {/* <Button
                bgColor={'bg-white'}
                color={'text-primary-50'}
                border="border-primary-50"
              >
                Browser
              </Button> */}
              <Upload
                accept=".xlsx,.xls,.csv"
                onChange={handleUploadFile}
                beforeUpload={() => false}
                fileList={[]}
                showUploadList={false}
              >
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  customClass="fix-border-radius"
                >
                  Browser
                </Button>
              </Upload>
            </Col>
          </Row>
        </Form>

        <div className="mt-4">
          <Table
            rowKey={(record) => record.id}
            columns={columns}
            scroll={{ x: 858 }}
            className="customTable"
            dataSource={donghangs}
            // loading={''}
            // pagination={{
            //   current: page,
            //   pageSize: page_size,
            //   total: donghangs.length,
            //   showSizeChanger: true,
            //   pageSizeOptions: ['10', '20', '50'],
            //   onChange: HocChangePagination(history),
            // }}
          />
        </div>

        <div className="mt-20 pt-4 border-t-2 border-neutral-90">
          <Form>
            <Row
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
              justify="end"
              className="mb-1"
            >
              <Col span={12} className="flex justify-end">
                <Space>
                  <Button
                    bgColor={'bg-white'}
                    color={'text-primary-50'}
                    border="border-primary-50"
                  >
                    Trở lại
                  </Button>
                  <Button
                    onClick={() => {
                      if (isTotalMinMaxInvalid() === true) {
                        handleUpdate();
                      } else {
                        openNotificationWithIcon(
                          'error',
                          'Khai báo không thành công',
                          'Tỷ trọng min, max không được lớn hơn 100%'
                        );
                      }
                    }}
                  >
                    Lưu phân bổ
                  </Button>
                </Space>
              </Col>
            </Row>
          </Form>
        </div>
      </Content>
    </MainLayout>
  );
}
